export class InzetPositiesOpTeVersterkenTreinModel {
  constructor(
    public positie: number,
    public volledigeNaam: string,
  ) {}
}

export function mapInzetPositiesOpTeVersterkenTrein(
  rawModel: InzetPositiesOpTeVersterkenTreinModel,
): InzetPositiesOpTeVersterkenTreinModel {
  return new InzetPositiesOpTeVersterkenTreinModel(rawModel.positie, rawModel.volledigeNaam);
}

export function mapArrayOfInzetPositiesOpTeVersterkenTrein(
  rawModel: InzetPositiesOpTeVersterkenTreinModel[],
): InzetPositiesOpTeVersterkenTreinModel[] {
  return rawModel.map(mapInzetPositiesOpTeVersterkenTrein);
}
